import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProyeccFinancierasRoutingModule } from './proyecc-financieras-routing.module';
import { ConfigCatalogoComponent } from './config-catalogo/config-catalogo.component';
import { SharedModule } from '../../shared/shared.module';
import { ConfigIndicadoresComponent } from './config-indicadores/config-indicadores.component';
import { CargaInformacionComponent } from './carga-informacion/carga-informacion.component';
import { EscenariosProyectadosComponent } from './escenarios-proyectados/escenarios-proyectados.component';
import { ProyeccionesComponent } from './proyecciones/proyecciones.component';


@NgModule({
  declarations: [
    ConfigCatalogoComponent,
    ConfigIndicadoresComponent,
    CargaInformacionComponent,
    EscenariosProyectadosComponent,
    ProyeccionesComponent
  ],
  imports: [
    CommonModule,
    ProyeccFinancierasRoutingModule,
    SharedModule
  ]
})
export class ProyeccFinancierasModule { }
